import React,{
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';
import {authService} from '../services/authService';

const AuthContext=createContext(null);

export function AuthProvider({children}) {
  const [user,setUser]=useState(null);
  const [token,setToken]=useState(null);
  const [loaded,setLoaded]=useState(false);

  useEffect(()=> {
    const savedToken=authService.getToken();
    const savedUser=authService.getUser();
    if (savedToken) {
      setToken(savedToken);
      setUser(savedUser);
    }
    setLoaded(true);
  },[]);

  const login=useCallback(async (email,password)=> {
    const data=await authService.login(email,password);
    if (data.requiresOtp) {
      return data;
    }
    const newToken=data.token || authService.getToken();
    const newUser=data.data || data.user || authService.getUser() || {email};
    setToken(newToken);
    setUser(newUser);
    return data;
  },[]);

  const register=useCallback(async (details)=> {
    return authService.register(details);
  },[]);

  const verifyOtp=useCallback(async (temporaryToken,otp,pendingUser)=> {
    const data=await authService.verifyOtp(temporaryToken,otp,pendingUser);
    const newToken=data.token || authService.getToken();
    const newUser=data.user || data.data || authService.getUser() || pendingUser;
    setToken(newToken);
    setUser(newUser);
    return data;
  },[]);

  const resendOtp=useCallback(async (email)=> {
    return authService.resendOtp(email);
  },[]);

  const logout=useCallback(()=> {
    authService.logout();
    setToken(null);
    setUser(null);
  },[]);

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        isLoggedIn: !!token,
        loaded,
        login,
        register,
        verifyOtp,
        resendOtp,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx=useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return ctx;
}